module.exports = __webpack_public_path__ + "img/stamp-plant.5cb004a9.png";